// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-mobilemain-container{display:flex;flex-direction:column;flex:1;overflow-y:scroll}\n", ""]);
// Exports
module.exports = exports;
